export enum UrlParamNames {
  FILTERS = 'filters',
  DATE = 'date',
  FIELDS = 'fields',
  LIMIT = 'limit',
  PAGE = 'page',
  SORT = 'sort',
  SEARCH = 'search',
}
